import React, { useEffect, useState } from "react";
import {  Col,  Form,  Input,  Modal,  Row,  Divider, theme,  message,} from "antd";
import { PATCH } from "../../../frameworks/HttpClient";
import { URL_SETTING } from "../../../constants/urls";
import { DATE_FORMAT } from "../../../constants/string";
import ErrorMessages from "../../../common/ErrorMessages";
import CustomDatePicker from "../../../common/CustomDatePicker";

export default function FactoryGeneralModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, factoryData, onUpdate } = props;
  const [errorMessages, setErrorMessages] = useState(null);

  const {
    token: { colorWarning },
  } = theme.useToken();

  useEffect(() => {
    if (factoryData) {
      form.setFieldsValue(factoryData);
    }
  }, [factoryData, form]);

  const handleOK = async () => {
    setErrorMessages(null);
    setLoading(true);
    try {
      const data = await form.validateFields();
      await PATCH(URL_SETTING.CONFIG_FACTORY, data);
      message.success("อัปเดตข้อมูลสำเร็จ");
      onUpdate();
    } catch (error) {
      setErrorMessages(error?.errorMessages || ["ผิดพลาด"]);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setErrorMessages(null)
  },[open])
  
  return (
    <Modal
      open={open}
      onCancel={onClose}
      cancelText="ยกเลิก"
      onOk={handleOK}
      title="ข้อมูลโรงงาน"
      width={600}
      okText={"แก้ไข"}
      destroyOnClose
      centered
      okButtonProps={{
        style: { backgroundColor: colorWarning },
        loading,
      }}
    >
      <ErrorMessages message={errorMessages}/>
      <Form form={form} layout="vertical" style={{ padding: "10px 20px" }}>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              label="ชื่อโรงงาน"
              name="NAME_TH"
              rules={[{ required: true, message: "กรุณากรอกชื่อโรงงาน" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="ที่อยู่"
              name="ADDRESS_TH"
              rules={[{ required: true, message: "กรุณากรอกที่อยู่" }]}
            >
              <Input.TextArea autoSize={{ minRows: 2, maxRows: 4 }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="เลขที่ประจำตัวผู้เสียภาษี"
              name="INVOICE_ID"
              rules={[
                {
                  required: true,
                  message: "กรุณากรอกเลขที่ประจำตัวผู้เสียภาษี",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="เบอร์โทรศัพท์" name="PHONE_NUMBER">
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Factory Name (EN)" name="NAME_EN">
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Address (EN)" name="ADDRESS_EN">
              <Input.TextArea autoSize={{ minRows: 2, maxRows: 4 }} />
            </Form.Item>
          </Col>
          <Divider>ข้อมูลใบอนุญาตค้ายาง</Divider>
          <Col span={12}>
            <Form.Item label="เลขที่ใบอนุญาตค้ายาง" name="LICENSE_NUMBER">
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <CustomDatePicker
              label="วันที่ใบอนุญาตค้ายางหมดอายุ"
              name="LICENSE_EXPIRE_DATE"
              rules={[{ required: false, message: "กรุณาระบุวันที่" }]}
              format={DATE_FORMAT}
            />
          </Col>
          <Col span={24}>
            <Form.Item label="ที่อยู่ตามใบอนุญาตค้ายาง" name="LICENSE_ADDRESS">
              <Input.TextArea autoSize={{ minRows: 2, maxRows: 4 }} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
